import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { Testimonials } from './components/Testimonials';
import { BigIdea } from './components/BigIdea';
import { PainSection } from './components/PainSection';
import { ProductReveal } from './components/ProductReveal';
import { BonusesSection } from './components/BonusesSection';
import { UrgencyBlock } from './components/UrgencyBlock';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { Reviews } from './components/Reviews';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { PurchaseToast } from './components/PurchaseToast';
import { PRODUCT_PARAMS, trackEvent } from './utils/tracking';
export function App() {
  useEffect(() => {
    trackEvent('ViewContent', PRODUCT_PARAMS);
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="5yjsutqtdfe">
      <div className="min-h-screen w-full overflow-x-clip bg-cream font-sans text-navy" data-id="element-1" data-mp="4wupmfw6qeo">
        <Header data-id="element-2" data-mp="2zlv84y2h77wn" />
        <main data-id="element-3" data-mp="2zmeoiach9o8k">
          <Hero data-id="element-4" data-mp="2zmwif0bo3qdb" />
          <StatsStrip data-id="element-5" data-mp="2zn678kkz7rhf" />
          <Testimonials variant="featured" data-id="element-6" data-mp="33mf1dqjxhrdi" />
          <BigIdea data-id="element-7" data-mp="33n6zp94wu37h" />
          <PainSection data-id="element-8" data-mp="33oriy2lrxzq1" />
          <ProductReveal data-id="element-9" data-mp="38lrrqla0dgku" />
          <BonusesSection data-id="element-10" data-mp="38li77d7qg1mj" />
          <UrgencyBlock data-id="element-11" data-mp="38k6vmr81ppkv" />
          <PricingSection data-id="element-12" data-mp="38o4h3ji3it7x" />
          <ComparisonTable data-id="element-13" data-mp="3dle1gkqmoeow" />
          <Testimonials variant="grid" data-id="element-14" data-mp="3dlntsez5axxr" />
          <Reviews data-id="element-15" data-mp="3dii4ozqinw21" />
          <Guarantee data-id="element-16" data-mp="nvstx4mognvy" />
          <FAQ data-id="element-17" data-mp="nwc582htoe10" />
          <CostOfInaction data-id="element-18" data-mp="nur7y544igzg" />
          <FinalCTA data-id="element-19" data-mp="nxn53r85d1mu" />
        </main>
        <Footer data-id="element-20" data-mp="su44jhksr2f8" />
        <StickyMobileCTA data-id="element-21" data-mp="stkne32z0i29" />
        <PurchaseToast data-id="element-22" data-mp="ssspumptca9c" />
      </div>
    </MotionConfig>;
}